import { jsx as r } from "react/jsx-runtime";
import o, { useRef as n } from "react";
const a = o.createContext({
  current: { zIndex: 0 }
}), x = ({ children: e }) => {
  const t = n({ zIndex: 0 });
  return /* @__PURE__ */ r(a.Provider, { value: t, children: e });
};
export {
  a as PageContext,
  x as PageProvider
};
